import {observer} from 'mobx-react';
import React from 'react';
import {InputAutoWidth} from '../../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {SelectQuestionEditStore, SelectStore} from '../SelectQuestionEditStore';

function AddSelectControl(props: { store: SelectQuestionEditStore, index: number }) {
  const {store, index} = props;
  return (
    <div className="row justify-content-end">
      <div className="col-auto">
        <button type="button" className="btn btn-outline-primary"
                onClick={() => store.addSelectStore(index)}>
          Add select
        </button>
      </div>
    </div>);
}

function* selectChoices(selectStore: SelectStore): ReactNodeGenerator {
  for (let i = 0; i < selectStore.choices.length; i++) {
    let choice = selectStore.choices[i];
    yield (
      <div className="col-auto" key={i}>
        <div className="select-choice">
          <input type="radio" className="form-check-input"
                 checked={choice.selected.value}
                 onChange={() => selectStore.selectChoice(i)}/>
          <InputAutoWidth font="normal 400 14px Roboto"
                          value={choice.label.value}
                          onChange={choice.label.onChangeHandler}/>
          <button type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => selectStore.removeChoice(i)}>
            <span className="fas fa-times"/>
          </button>
        </div>
      </div>
    );
  }
  yield (
    <div className="col-auto ml-auto" key="add">
      <button type="button"
              className="btn btn-outline-primary"
              onClick={() => selectStore.addChoice()}>
        <span className="fas fa-plus"/>
      </button>
    </div>);
}

function* renderer(store: SelectQuestionEditStore): ReactNodeGenerator {
  const hasExtra = store.hasExtraSelectStores;
  const hasMissing = store.hasMissingSelectStores;

  for (let i = 0; i < store.selectStores.length; i++) {
    const first = i === 0;
    const last = i === store.selectStores.length - 1;
    const selectStore = store.selectStores[i];

    if (hasMissing)
      yield <AddSelectControl store={store}
                              index={i}
                              key={'add-select-' + i}/>;

    yield (
      <div className="row" key={'choices-' + i}>
        {Array.from(selectChoices(selectStore))}
      </div>
    );

    yield (
      <div className="row" key={i}>
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
                  disabled={first}
                  onClick={() => store.swapUp(i)}>
            <span className="fas fa-angle-double-up"/>
          </button>
          <button type="button" className="btn btn-primary"
                  disabled={last}
                  onClick={() => store.swapDown(i)}>
            <span className="fas fa-angle-double-down"/>
          </button>
          {
            hasExtra &&
            <button type="button" className="btn btn-outline-primary"
                    onClick={() => store.removeSelectStore(i)}>
              <span className="fas fa-times"/>
            </button>
          }
        </div>
      </div>
    );
  }

  if (hasMissing)
    yield <AddSelectControl store={store}
                            index={store.selectStores.length}
                            key={'add-select-' + store.selectStores.length}/>;

  if (hasMissing)
    yield (
      <div className="row" key="missing">
        <div className="col">
          <div className="alert alert-danger">
            Missing {store.selectCountFromSerialized - store.selectStores.length} selects.
          </div>
        </div>
      </div>);

  if (hasExtra)
    yield (
      <div className="row" key="extra">
        <div className="col">
          <div className="alert alert-danger">
            Extra {store.selectStores.length - store.selectCountFromSerialized} selects.
          </div>
        </div>
      </div>);
}

@observer
export class SelectSpecifications extends React.Component<{ store: SelectQuestionEditStore }> {
  render() {
    return Array.from(renderer(this.props.store));
  }
}
